module.exports = __webpack_public_path__ + "img/L_316_325.c038048f.png";